module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_location-e8a442a18d42c4616d4458bd822cb2ef.webp";